// One place for the details shown on the Privacy / Terms / Delete-account pages and in the apps.
// TODO(owner): replace SUPPORT_EMAIL with the mailbox you actually read before submitting the apps.
export const APP_NAME = "FNJEE";
export const SITE = "https://fnjee.com";
export const SUPPORT_EMAIL = "support@fnjee.com";
export const OPERATOR = "FNJEE.com";
export const LEGAL_UPDATED = "1 November 2026";
